import React from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { PRODUCTS } from "../data/content";
import { FadeUp, Stagger, StaggerItem } from "./Motion";

const ProductShowcase = () => {
  return (
    <section
      data-testid="product-showcase"
      className="py-24 md:py-32 bg-cream-2"
    >
      <div className="container mx-auto px-6 md:px-10 xl:px-16">
        <FadeUp className="flex flex-col md:flex-row md:items-end md:justify-between mb-20 gap-8">
          <div className="max-w-2xl">
            <p className="eyebrow text-forest">What We Offer</p>
            <h2 className="mt-4 font-serif text-4xl md:text-5xl lg:text-6xl tracking-tight text-forest leading-[1.05]">
              Three verticals. <em className="italic text-saffron">One</em> uncompromising standard.
            </h2>
          </div>
          <p className="max-w-md text-muted-ink">
            Each vertical at Rudrash is engineered end-to-end — from cultivation chamber to packaging — for traceability, freshness and ethics.
          </p>
        </FadeUp>

        <Stagger className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
          {PRODUCTS.map((p, i) => (
            <StaggerItem key={p.id}>
              <Link
                to={p.slug}
                data-testid={`product-card-${p.id}`}
                className="group relative block overflow-hidden bg-cream h-[520px]"
              >
                <img
                  src={p.image}
                  alt={p.title}
                  loading="lazy"
                  className="absolute inset-0 w-full h-full object-cover transition-transform duration-[1400ms] ease-out group-hover:scale-[1.08]"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-forest via-forest/20 to-transparent" />
                <div className="absolute top-6 left-6 z-10 flex items-center gap-2">
                  <span className="eyebrow text-saffron">0{i + 1}</span>
                </div>
                <div className="absolute bottom-0 left-0 right-0 p-8 text-cream z-10">
                  <p className="eyebrow text-cream/70">{p.tagline}</p>
                  <h3 className="mt-3 font-serif text-4xl md:text-5xl tracking-tight">
                    {p.title}
                  </h3>
                  <div className="mt-6 flex items-center justify-between">
                    <span className="link-underline">
                      Discover more
                    </span>
                    <span className="w-10 h-10 flex items-center justify-center border border-cream/40 group-hover:bg-saffron group-hover:border-saffron transition-colors">
                      <ArrowUpRight size={16} />
                    </span>
                  </div>
                </div>
              </Link>
            </StaggerItem>
          ))}
        </Stagger>
      </div>
    </section>
  );
};

export default ProductShowcase;
